export default __webpack_public_path__ + "static/media/creditoja-blog1.88ed2744.jpg";